import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart } from "@angular/router";
import { PAGES_WITHOUT_LOGIN, PROJECT_CONFIG } from "./config/project";
import { GLOBAL_CLASSES } from "./config/globalClasses";
import { KEYBOARD_SETTINGS } from "./config/keyboard_settings";
import { NETWORK_PX } from "./config/api";
import { PARTNERS } from "./config/partners_settings";
import { Event } from './service/sockets/model/event';
import NoSleep from 'nosleep.js';
var AppComponent = /** @class */ (function () {
    function AppComponent(socketService, menuService, router, phoneService, stripeService, appVersionrService, installService, prizesService, menuBottomAddContentService, connectionService, popupComponent, partnerService, terminalService, auth, activatedRoute, usersPointService, appTestService, keyboardService, appPromptService, kioskService, kioskAccessorService, heroService, loginService, frontendTestSettingsService, document) {
        var _this = this;
        this.socketService = socketService;
        this.menuService = menuService;
        this.router = router;
        this.phoneService = phoneService;
        this.stripeService = stripeService;
        this.appVersionrService = appVersionrService;
        this.installService = installService;
        this.prizesService = prizesService;
        this.menuBottomAddContentService = menuBottomAddContentService;
        this.connectionService = connectionService;
        this.popupComponent = popupComponent;
        this.partnerService = partnerService;
        this.terminalService = terminalService;
        this.auth = auth;
        this.activatedRoute = activatedRoute;
        this.usersPointService = usersPointService;
        this.appTestService = appTestService;
        this.keyboardService = keyboardService;
        this.appPromptService = appPromptService;
        this.kioskService = kioskService;
        this.kioskAccessorService = kioskAccessorService;
        this.heroService = heroService;
        this.loginService = loginService;
        this.frontendTestSettingsService = frontendTestSettingsService;
        this.document = document;
        this.signup = false;
        this.login = false;
        this.search = true;
        this.canListen = false;
        this.androidInstallBtn = false;
        this.IOSInstallBtn = false;
        this.userLoggedStatus = false;
        this.noInternetConnection = false;
        this.isConnected = true;
        this.isApp = null;
        this.messages = [];
        this.PROJECT_CONFIG = PROJECT_CONFIG;
        this.showPopupGettingMoney = false;
        this.networkStatus = true;
        // Detects if device is in standalone mode
        this.isInStandaloneMode = function () { return ('standalone' in window.navigator) && (window.navigator['standalone']); };
        this.isApp = this.kioskService.isKiosk();
        this.router.events.subscribe(function (event) {
            if (event instanceof NavigationStart) {
                //console.log('Navigation Start')
                _this.canListen = false;
            }
            if (event instanceof NavigationEnd) {
                //console.log('Navigation End')
                if (event.url.indexOf('/home/prizes/paypal')) {
                    _this.prizesService.temporaryEmail.next('');
                }
                if (event.url.indexOf('/home/prizes/mail-check')) {
                    _this.prizesService.temporaryAddress.next('');
                }
                var snakeBtns = document.querySelectorAll('.snake-btn');
                snakeBtns.forEach(function (el) {
                    el.classList.add('is-notouched');
                });
                setTimeout(function () {
                    _this.canListen = true;
                }, 0);
                _this.setBodyClassForLongContent();
                window.addEventListener('resize', function () {
                    _this.setBodyClassForLongContent();
                });
                _this.appHeight();
            }
        });
        if (this.frontendTestSettingsService.isHideForTesting()) {
            this.networkResponse();
        }
        //this.partnerService.detectPartner();
        this.onPopupGettingMoneyToggle();
        var $this = this;
        this.auth.userLoggedStatusChanged.subscribe(function (value) { return _this.logged(value); });
        document.body.addEventListener('click', function (e) {
            //console.log('clicked body');
        });
        this.checkMascotSinglePage();
    }
    AppComponent.prototype.clickInside = function (event) {
        if (this.canListen) {
            var snakeBtns = document.querySelectorAll('.is-notouched');
            snakeBtns.forEach(function (el) {
                el.classList.remove('is-notouched');
            });
        }
        ;
    };
    AppComponent.prototype.handleTouch = function (event) {
        if (this.isApp || this.partnerService.isMascotSingle()) {
            if (this.isApp) {
                this.keyboardService.activityTimer.next(this.keyboardService.timer);
            }
            var inputs = document.querySelectorAll(KEYBOARD_SETTINGS.excludedInputs);
            if (!(typeof event.target.className === "string" && event.target.className.indexOf('keyboard') !== -1) &&
                (event.target.nodeName !== 'INPUT' || event.target.type === 'radio' || event.target.type === 'checkbox') &&
                !this.partnerService.isMascotSingle()) {
                this.keyboardService.keyboardVisible.next(false);
                inputs.forEach(function (el) {
                    el.scrollLeft = el.scrollWidth;
                });
            }
            else if (!this.showPopupGettingMoney && inputs.length) {
                this.keyboardService.showKeyboard();
            }
        }
    };
    AppComponent.prototype.onbeforeinstallprompt = function (e) {
        e.preventDefault();
        // store install avaliable event
        this.deferredPrompt = e;
        //console.log(e);
        // show button with display:block;
        this.appPromptService.deferredPrompt = this.deferredPrompt;
    };
    AppComponent.prototype.checkMascotSinglePage = function () {
        // this.partnerService.currentPartnerTemplate.subscribe(val => {
        //     if (val) {
        //         if (this.partnerService.isMascotSingle() && !this.auth.isUserLogged()) {
        //             // this.router.navigate([RouterPaths.mascot.main], {queryParams: {logged: false}});
        //             console.log("RouterPaths.mascot.main 3");
        //             this.router.navigate([RouterPaths.mascot.main], {queryParams: {notLogged: true}, queryParamsHandling: 'merge'});
        //         }
        //     }
        // });
    };
    AppComponent.prototype.logged = function (value) {
        if (!value) {
            this.showPopupGettingMoney = false;
            document.body.classList.remove('blur-page');
        }
    };
    AppComponent.prototype.networkResponse = function () {
        var _this = this;
        if (this.isApp) {
            this.networkResponseIco();
        }
        this.connectionService.monitor().subscribe(function (isConnected) {
            _this.isConnected = isConnected;
            if (_this.isConnected) {
                _this.noInternetConnection = false;
                _this.popupComponent.closePopup();
            }
            else {
                _this.noNetwork();
            }
        });
    };
    AppComponent.prototype.networkResponseIco = function () {
        var _this = this;
        fetch(NETWORK_PX + '?d=' + Date.now())
            .then(function (response) {
            if (!response.ok) {
                _this.noNetwork();
                return;
            }
            if (!_this.networkStatus) {
                _this.networkStatus = true;
                _this.noInternetConnection = false;
                _this.popupComponent.closePopup();
            }
        })
            .catch(function (error) {
            _this.noNetwork();
        });
        var $this = this;
        setTimeout(function () {
            $this.networkResponseIco();
        }, 5000);
    };
    AppComponent.prototype.noNetwork = function () {
        if (this.networkStatus) {
            this.networkStatus = false;
            this.noInternetConnection = true;
            this.popupComponent.showPopupError({ text: 'No Internet Connection: please, try to connect to the Internet', closeBtn: false });
            this.auth.logout();
        }
    };
    AppComponent.prototype.userLogged = function () {
        var _this = this;
        this.auth.userLoggedStatusChanged.subscribe(function (val) {
            if (_this.userLoggedStatus !== val && val === false) {
                _this.userLoggedStatus = val;
                var isMascotSingle = _this.partnerService.isMascotSingle();
                if (isMascotSingle) {
                }
                else {
                    _this.router.navigate(['/'], { queryParams: { logout: true } });
                }
            }
            else {
                _this.userLoggedStatus = val;
            }
        });
    };
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.partnerService.storageGetCurrentPartner() && PAGES_WITHOUT_LOGIN.indexOf(window.location.pathname) === -1) {
            console.log('app partner');
            this.router.navigate(['/']);
        }
        if (this.isApp) {
            if (!this.terminalService.isInfo()) {
                console.log('app terminal');
                this.router.navigate(['/']);
            }
        }
        this.userLogged();
        if (this.heroService.isCryptoVersion() && !this.isApp) {
            this.document.body.classList.add('v-crypto');
        }
        this.setCorrectThumbnailIcon();
        this.phoneService.init();
        this.setPointHash();
        this.setWebTest();
        this.loginService.loginChanged.subscribe(function (value) { return _this.loginChanged(value); });
        setTimeout(function () {
            _this.menuService.menuChanged.subscribe(function (value) { return _this.menuChanged(value); });
        });
        this.activatedRoute.queryParams.subscribe(function (params) {
            _this.detectBrowser();
        });
        this.refreshToken();
        this.appVersion();
        this.visibilitychange();
        window.addEventListener('resize', this.appHeight);
        window.addEventListener('orientationchange', this.appHeight);
        this.appHeight();
        this.setKioskClass();
        this.setBodyClassForLongContent();
        //this.initIoConnection();
        this.setNoScreenLock();
    };
    AppComponent.prototype.ngOnDestroy = function () {
    };
    AppComponent.prototype.initIoConnection = function () {
        var _this = this;
        this.socketService.initSocket();
        this.ioConnection = this.socketService.onMessage()
            .subscribe(function (message) {
            _this.messages.push(message);
        });
        this.socketService.onEvent(Event.CONNECT)
            .subscribe(function () {
            console.log('connected');
        });
        this.socketService.onEvent(Event.DISCONNECT)
            .subscribe(function () {
            console.log('disconnected');
        });
    };
    AppComponent.prototype.onPopupGettingMoneyToggle = function () {
        var _this = this;
        this.kioskAccessorService.paymentAmountChanged.subscribe(function (amount) {
            if (amount > 0) {
                _this.showPopupGettingMoney = true;
                _this.amountMoneyInTerminal = amount;
                _this.keyboardService.keyboardVisible.next(false);
                document.body.classList.add('blur-page');
            }
            else {
                _this.showPopupGettingMoney = false;
                document.body.classList.remove('blur-page');
            }
        });
    };
    AppComponent.prototype.visibilitychange = function () {
        var _this = this;
        this.auth.setStamp();
        document.addEventListener('visibilitychange', function () {
            // alert(document.hidden)
            if (document.hidden == false) {
                _this.auth.checkStamp();
            }
            else {
            }
        }, false);
    };
    AppComponent.prototype.setPointHash = function () {
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            try {
                if (params['point']) {
                    if (params['point'] != '') {
                        _this.usersPointService.saveHashInStorage(params['point']);
                    }
                }
            }
            catch (e) {
            }
        });
    };
    AppComponent.prototype.setWebTest = function () {
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            try {
                if (params['iswebtest']) {
                    if (params['iswebtest'] != '') {
                        _this.appTestService.saveInStorage(params['iswebtest']);
                    }
                }
                else {
                    _this.appTestService.clearStorage();
                }
            }
            catch (e) {
            }
        });
    };
    AppComponent.prototype.appVersion = function () {
        this.appVersionrService.checkVersion();
    };
    AppComponent.prototype.refreshToken = function () {
        var $this = this;
        setTimeout(function () {
            $this.auth.refreshToken();
        }, 60 * 5 * 1000);
    };
    AppComponent.prototype.addStripeJs = function (key) {
        this.stripeService.setPublishableKey(key);
    };
    AppComponent.prototype.menuChanged = function (status) {
        this.menu = status;
    };
    AppComponent.prototype.signUpChanged = function (status) {
        this.signup = status;
    };
    AppComponent.prototype.loginChanged = function (status) {
        this.login = status;
    };
    AppComponent.prototype.searchVisibilityChanged = function (value) {
        this.search = value;
    };
    AppComponent.prototype.addToHomeScreen = function () {
        // wait for click install button by user
        var _this = this;
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then(function (choiceResult) {
            if (choiceResult.outcome === 'accepted') {
                // user accept the prompt
                // lets hidden button
                _this.androidInstallBtn = false;
                //overlay_button.classList.add('is-app');
            }
            else {
                console.log('User dismissed the prompt');
            }
            //this.deferredPrompt = null;
        });
    };
    AppComponent.prototype.detectBrowser = function () {
        // let pointSubdomain = this.usersPointService.isPointSubdomain();
        // if (pointSubdomain) {
        //     this.installService.hide();
        //     this.IOSInstallBtn = false;
        //     return;
        // }
        var isLoginPage = location.pathname === '/' || location.pathname === '';
        if (window.matchMedia('(display-mode: standalone)').matches || window.innerWidth >= 600 || !isLoginPage) {
            this.installService.appInstalled.next(true);
            this.installService.hide();
            this.IOSInstallBtn = false;
        }
        else {
            this.installService.show();
        }
    };
    AppComponent.prototype.appHeight = function () {
        setTimeout(function () {
            var doc = document.documentElement;
            doc.style.setProperty('--app-height', window.innerHeight + "px");
            doc.style.setProperty('--app-width', window.innerWidth + "px");
        }, 0);
    };
    AppComponent.prototype.setKioskClass = function () {
        if (this.kioskService.isKiosk()) {
            document.body.classList.add(GLOBAL_CLASSES.kioskApp);
        }
    };
    AppComponent.prototype.setBodyClassForLongContent = function () {
        setTimeout(function () {
            var pageEl = document.body.querySelector('.page');
            var body = document.body;
            var maxAspectRatio = 10 / 8;
            var minAspectRatio = 10 / 11;
            var minWidth = 1280;
            var currentRatio = window.innerWidth / window.innerHeight;
            var ifSquareRatio = currentRatio <= maxAspectRatio && currentRatio >= minAspectRatio && minWidth <= window.innerWidth;
            // if (pageEl && pageEl.classList.contains(GLOBAL_CLASSES.pageLongContent) && this.kioskService.isKiosk()) {
            //     body.classList.add(GLOBAL_CLASSES.pageLongContent);
            // } else {
            //     body.classList.remove(GLOBAL_CLASSES.pageLongContent);
            // }
            // if (!this.kioskService.isKiosk() && pageEl) {
            //     pageEl.classList.remove(GLOBAL_CLASSES.pageLongContent);
            // }
            // if (this.kioskService.isKiosk()) {
            //     body.classList.add(GLOBAL_CLASSES.kioskApp);
            // } else {
            //     body.classList.remove(GLOBAL_CLASSES.kioskApp);
            // }
            if (pageEl && pageEl.classList.contains(GLOBAL_CLASSES.pageLongContent)) {
                // body.classList.add(GLOBAL_CLASSES.pageLongContent);
            }
            else {
                body.classList.remove(GLOBAL_CLASSES.pageLongContent);
            }
            if (!ifSquareRatio && pageEl) {
                body.classList.remove(GLOBAL_CLASSES.pageLongContent);
                pageEl.classList.remove(GLOBAL_CLASSES.pageLongContent);
            }
            if (ifSquareRatio) {
                body.classList.add('is-square');
            }
            else {
                body.classList.remove('is-square');
            }
        }, 600);
    };
    AppComponent.prototype.setCorrectThumbnailIcon = function () {
        var partner = this.partnerService.getShortName();
        if (partner === PARTNERS.snekapek.short_name || partner === PARTNERS.sap.short_name) {
            this.changeThumbnailIcons(PARTNERS.snekapek.short_name);
        }
        if (partner === PARTNERS.mascot.short_name) {
            this.changeThumbnailIcons(PARTNERS.mascot.short_name);
        }
        if (partner === PARTNERS.senet.short_name || partner === PARTNERS.senetLabel.short_name) {
            this.changeThumbnailIcons(PARTNERS.senet.short_name);
            document.querySelector('title').innerHTML = this.partnerService.getBusinessName();
        }
        if (partner === PARTNERS.kashQueen.short_name) {
            this.changeThumbnailIcons('kashqueen');
            if (this.partnerService.getBusinessName()) {
                document.querySelector('title').innerHTML = this.partnerService.getBusinessName();
            }
        }
    };
    AppComponent.prototype.changeThumbnailIcon = function (selector, icon, partner) {
        var defaultIcon = document.querySelector(selector).getAttribute('href');
        var newIcon = defaultIcon.split('/icons')[0] + ("/partners/" + partner + "/icons/" + icon);
        document.querySelector(selector).setAttribute('href', newIcon);
    };
    AppComponent.prototype.changeThumbnailIcons = function (partner) {
        this.changeThumbnailIcon('link[rel="icon"]', 'icon-72.png', partner);
        this.changeThumbnailIcon('link[rel="apple-touch-icon"][sizes="180x180"]', 'icon-180.png', partner);
        this.changeThumbnailIcon('link[rel="apple-touch-icon"][sizes="120x120"]', 'icon-120.png', partner);
    };
    // setNoScreenLock() {
    //   this.noSleep = new NoSleep();
    //   const $this = this;
    //   document.addEventListener('click', function enableNoSleep() {
    //     document.removeEventListener('click', enableNoSleep, false);
    //     $this.noSleep.enable(); // on
    //     // $this.noSleep.disable(); off
    //   }, false);
    // }
    AppComponent.prototype.setNoScreenLock = function () {
        var _this = this;
        if ('wakeLock' in navigator) {
            this.isSupportedSleep = true;
        }
        if (this.isSupportedSleep) {
            // create a reference for the wake lock
            var wakeLock_1 = null;
            // create an async function to request a wake lock
            var requestWakeLock_1 = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var err_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, navigator.wakeLock.request('screen')];
                        case 1:
                            wakeLock_1 = _a.sent();
                            // listen for our release event
                            wakeLock_1.onrelease = function (ev) {
                                //console.log(ev);
                            };
                            wakeLock_1.addEventListener('release', function () {
                                // if wake lock is released alter the button accordingly
                                //changeUI('released');
                            });
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }; // requestWakeLock()
            document.addEventListener('click', function enableNoSleep() {
                document.removeEventListener('click', enableNoSleep, false);
                requestWakeLock_1();
            }, false);
        }
        else {
            this.noSleep = new NoSleep();
            var $this_1 = this;
            document.addEventListener('click', function enableNoSleep() {
                document.removeEventListener('click', enableNoSleep, false);
                $this_1.noSleep.enable().then($this_1.updateSwitchStatus.bind($this_1));
            }, false);
        }
    };
    AppComponent.prototype.updateSwitchStatus = function () {
        var enabled = this.noSleep.isEnabled;
        if (this.noSleep._wakeLock) {
            enabled = !this.noSleep._wakeLock.released;
        }
        if (enabled) {
            console.log("noSleep is enabled");
        }
        else {
            console.log("noSleep is disabled");
        }
    };
    return AppComponent;
}());
export { AppComponent };
